/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {AvailableHarvestPlants} from '../bioplanModels';
// @ts-ignore
import type {CreateHarvestPlant} from '../bioplanModels';
// @ts-ignore
import type {CreateHarvestPlantShift} from '../bioplanModels';
// @ts-ignore
import type {EditHarvestPlant} from '../bioplanModels';
// @ts-ignore
import type {EditHarvestPlantShift} from '../bioplanModels';
// @ts-ignore
import type {HarvestPlant} from '../bioplanModels';
// @ts-ignore
import type {HarvestPlantCapacity} from '../bioplanModels';
// @ts-ignore
import type {HarvestPlantShift} from '../bioplanModels';
/**
 * PlanningHarvestPlantsApi - axios parameter creator
 * @export
 */
export const PlanningHarvestPlantsApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get packaging codes
     * @param {string} siteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestPlantsAvailableGet: async (siteId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'siteId' is not null or undefined
      assertParamExists('harvestPlantsAvailableGet', 'siteId', siteId);
      const localVarPath = `/harvestPlants/available`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (siteId !== undefined) {
        localVarQueryParameter['siteId'] = siteId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all harvest plant capacity for queried plan
     * @param {string} planId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {Array<string>} [harvestPlantIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestPlantsCapacityGet: async (
      planId: string,
      startDate?: string,
      endDate?: string,
      harvestPlantIds?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('harvestPlantsCapacityGet', 'planId', planId);
      const localVarPath = `/harvestPlants/capacity`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString().substring(0, 10) : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString().substring(0, 10) : endDate;
      }

      if (harvestPlantIds) {
        localVarQueryParameter['harvestPlantIds'] = harvestPlantIds;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all harvest plants for queried plan
     * @param {Array<string>} planIds
     * @param {string} [siteId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestPlantsGet: async (
      planIds: Array<string>,
      siteId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planIds' is not null or undefined
      assertParamExists('harvestPlantsGet', 'planIds', planIds);
      const localVarPath = `/harvestPlants/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planIds) {
        localVarQueryParameter['planIds'] = planIds;
      }

      if (siteId !== undefined) {
        localVarQueryParameter['siteId'] = siteId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete harvest plant by its identifier
     * @param {string} harvestPlantId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestPlantsHarvestPlantIdDelete: async (
      harvestPlantId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'harvestPlantId' is not null or undefined
      assertParamExists('harvestPlantsHarvestPlantIdDelete', 'harvestPlantId', harvestPlantId);
      const localVarPath = `/harvestPlants/{harvestPlantId}`.replace(
        `{${'harvestPlantId'}}`,
        encodeURIComponent(String(harvestPlantId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get harvest plant by its identifier.
     * @param {string} harvestPlantId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestPlantsHarvestPlantIdGet: async (
      harvestPlantId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'harvestPlantId' is not null or undefined
      assertParamExists('harvestPlantsHarvestPlantIdGet', 'harvestPlantId', harvestPlantId);
      const localVarPath = `/harvestPlants/{harvestPlantId}`.replace(
        `{${'harvestPlantId'}}`,
        encodeURIComponent(String(harvestPlantId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update a harvest plant
     * @param {string} harvestPlantId
     * @param {EditHarvestPlant} editHarvestPlant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestPlantsHarvestPlantIdPut: async (
      harvestPlantId: string,
      editHarvestPlant: EditHarvestPlant,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'harvestPlantId' is not null or undefined
      assertParamExists('harvestPlantsHarvestPlantIdPut', 'harvestPlantId', harvestPlantId);
      // verify required parameter 'editHarvestPlant' is not null or undefined
      assertParamExists('harvestPlantsHarvestPlantIdPut', 'editHarvestPlant', editHarvestPlant);
      const localVarPath = `/harvestPlants/{harvestPlantId}`.replace(
        `{${'harvestPlantId'}}`,
        encodeURIComponent(String(harvestPlantId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(editHarvestPlant, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get harvest plant shifts.
     * @param {string} harvestPlantId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestPlantsHarvestPlantIdShiftsGet: async (
      harvestPlantId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'harvestPlantId' is not null or undefined
      assertParamExists('harvestPlantsHarvestPlantIdShiftsGet', 'harvestPlantId', harvestPlantId);
      const localVarPath = `/harvestPlants/{harvestPlantId}/shifts`.replace(
        `{${'harvestPlantId'}}`,
        encodeURIComponent(String(harvestPlantId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Delete harvest plant shift.
     * @param {string} harvestPlantId
     * @param {string} harvestPlantShiftId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdDelete: async (
      harvestPlantId: string,
      harvestPlantShiftId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'harvestPlantId' is not null or undefined
      assertParamExists('harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdDelete', 'harvestPlantId', harvestPlantId);
      // verify required parameter 'harvestPlantShiftId' is not null or undefined
      assertParamExists(
        'harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdDelete',
        'harvestPlantShiftId',
        harvestPlantShiftId,
      );
      const localVarPath = `/harvestPlants/{harvestPlantId}/shifts/{harvestPlantShiftId}`
        .replace(`{${'harvestPlantId'}}`, encodeURIComponent(String(harvestPlantId)))
        .replace(`{${'harvestPlantShiftId'}}`, encodeURIComponent(String(harvestPlantShiftId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get harvest plant shift by its identifier.
     * @param {string} harvestPlantId
     * @param {string} harvestPlantShiftId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdGet: async (
      harvestPlantId: string,
      harvestPlantShiftId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'harvestPlantId' is not null or undefined
      assertParamExists('harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdGet', 'harvestPlantId', harvestPlantId);
      // verify required parameter 'harvestPlantShiftId' is not null or undefined
      assertParamExists(
        'harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdGet',
        'harvestPlantShiftId',
        harvestPlantShiftId,
      );
      const localVarPath = `/harvestPlants/{harvestPlantId}/shifts/{harvestPlantShiftId}`
        .replace(`{${'harvestPlantId'}}`, encodeURIComponent(String(harvestPlantId)))
        .replace(`{${'harvestPlantShiftId'}}`, encodeURIComponent(String(harvestPlantShiftId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Update harvest plant shift.
     * @param {string} harvestPlantId
     * @param {string} harvestPlantShiftId
     * @param {EditHarvestPlantShift} editHarvestPlantShift
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdPut: async (
      harvestPlantId: string,
      harvestPlantShiftId: string,
      editHarvestPlantShift: EditHarvestPlantShift,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'harvestPlantId' is not null or undefined
      assertParamExists('harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdPut', 'harvestPlantId', harvestPlantId);
      // verify required parameter 'harvestPlantShiftId' is not null or undefined
      assertParamExists(
        'harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdPut',
        'harvestPlantShiftId',
        harvestPlantShiftId,
      );
      // verify required parameter 'editHarvestPlantShift' is not null or undefined
      assertParamExists(
        'harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdPut',
        'editHarvestPlantShift',
        editHarvestPlantShift,
      );
      const localVarPath = `/harvestPlants/{harvestPlantId}/shifts/{harvestPlantShiftId}`
        .replace(`{${'harvestPlantId'}}`, encodeURIComponent(String(harvestPlantId)))
        .replace(`{${'harvestPlantShiftId'}}`, encodeURIComponent(String(harvestPlantShiftId)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(editHarvestPlantShift, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Add harvest plant shift.
     * @param {string} harvestPlantId
     * @param {CreateHarvestPlantShift} createHarvestPlantShift
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestPlantsHarvestPlantIdShiftsPost: async (
      harvestPlantId: string,
      createHarvestPlantShift: CreateHarvestPlantShift,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'harvestPlantId' is not null or undefined
      assertParamExists('harvestPlantsHarvestPlantIdShiftsPost', 'harvestPlantId', harvestPlantId);
      // verify required parameter 'createHarvestPlantShift' is not null or undefined
      assertParamExists('harvestPlantsHarvestPlantIdShiftsPost', 'createHarvestPlantShift', createHarvestPlantShift);
      const localVarPath = `/harvestPlants/{harvestPlantId}/shifts`.replace(
        `{${'harvestPlantId'}}`,
        encodeURIComponent(String(harvestPlantId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        createHarvestPlantShift,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Create harvest plant
     * @param {CreateHarvestPlant} createHarvestPlant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestPlantsPost: async (
      createHarvestPlant: CreateHarvestPlant,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'createHarvestPlant' is not null or undefined
      assertParamExists('harvestPlantsPost', 'createHarvestPlant', createHarvestPlant);
      const localVarPath = `/harvestPlants/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(createHarvestPlant, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlanningHarvestPlantsApi - functional programming interface
 * @export
 */
export const PlanningHarvestPlantsApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanningHarvestPlantsApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get packaging codes
     * @param {string} siteId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestPlantsAvailableGet(
      siteId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AvailableHarvestPlants>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestPlantsAvailableGet(siteId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestPlantsApi.harvestPlantsAvailableGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all harvest plant capacity for queried plan
     * @param {string} planId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {Array<string>} [harvestPlantIds]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestPlantsCapacityGet(
      planId: string,
      startDate?: string,
      endDate?: string,
      harvestPlantIds?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarvestPlantCapacity>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestPlantsCapacityGet(
        planId,
        startDate,
        endDate,
        harvestPlantIds,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestPlantsApi.harvestPlantsCapacityGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all harvest plants for queried plan
     * @param {Array<string>} planIds
     * @param {string} [siteId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestPlantsGet(
      planIds: Array<string>,
      siteId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HarvestPlant>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestPlantsGet(planIds, siteId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestPlantsApi.harvestPlantsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete harvest plant by its identifier
     * @param {string} harvestPlantId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestPlantsHarvestPlantIdDelete(
      harvestPlantId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestPlantsHarvestPlantIdDelete(
        harvestPlantId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestPlantsApi.harvestPlantsHarvestPlantIdDelete']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get harvest plant by its identifier.
     * @param {string} harvestPlantId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestPlantsHarvestPlantIdGet(
      harvestPlantId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarvestPlant>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestPlantsHarvestPlantIdGet(harvestPlantId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestPlantsApi.harvestPlantsHarvestPlantIdGet']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update a harvest plant
     * @param {string} harvestPlantId
     * @param {EditHarvestPlant} editHarvestPlant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestPlantsHarvestPlantIdPut(
      harvestPlantId: string,
      editHarvestPlant: EditHarvestPlant,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarvestPlant>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestPlantsHarvestPlantIdPut(
        harvestPlantId,
        editHarvestPlant,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestPlantsApi.harvestPlantsHarvestPlantIdPut']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get harvest plant shifts.
     * @param {string} harvestPlantId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestPlantsHarvestPlantIdShiftsGet(
      harvestPlantId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HarvestPlantShift>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestPlantsHarvestPlantIdShiftsGet(
        harvestPlantId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestPlantsApi.harvestPlantsHarvestPlantIdShiftsGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete harvest plant shift.
     * @param {string} harvestPlantId
     * @param {string} harvestPlantShiftId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdDelete(
      harvestPlantId: string,
      harvestPlantShiftId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HarvestPlantShift>>> {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdDelete(
          harvestPlantId,
          harvestPlantShiftId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestPlantsApi.harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get harvest plant shift by its identifier.
     * @param {string} harvestPlantId
     * @param {string} harvestPlantShiftId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdGet(
      harvestPlantId: string,
      harvestPlantShiftId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarvestPlantShift>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdGet(
        harvestPlantId,
        harvestPlantShiftId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestPlantsApi.harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update harvest plant shift.
     * @param {string} harvestPlantId
     * @param {string} harvestPlantShiftId
     * @param {EditHarvestPlantShift} editHarvestPlantShift
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdPut(
      harvestPlantId: string,
      harvestPlantShiftId: string,
      editHarvestPlantShift: EditHarvestPlantShift,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarvestPlantShift>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdPut(
        harvestPlantId,
        harvestPlantShiftId,
        editHarvestPlantShift,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestPlantsApi.harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdPut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Add harvest plant shift.
     * @param {string} harvestPlantId
     * @param {CreateHarvestPlantShift} createHarvestPlantShift
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestPlantsHarvestPlantIdShiftsPost(
      harvestPlantId: string,
      createHarvestPlantShift: CreateHarvestPlantShift,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarvestPlantShift>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestPlantsHarvestPlantIdShiftsPost(
        harvestPlantId,
        createHarvestPlantShift,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestPlantsApi.harvestPlantsHarvestPlantIdShiftsPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create harvest plant
     * @param {CreateHarvestPlant} createHarvestPlant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestPlantsPost(
      createHarvestPlant: CreateHarvestPlant,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarvestPlant>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestPlantsPost(createHarvestPlant, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningHarvestPlantsApi.harvestPlantsPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PlanningHarvestPlantsApi - factory interface
 * @export
 */
export const PlanningHarvestPlantsApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PlanningHarvestPlantsApiFp(configuration);
  return {
    /**
     *
     * @summary Get packaging codes
     * @param {PlanningHarvestPlantsApiHarvestPlantsAvailableGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestPlantsAvailableGet(
      requestParameters: PlanningHarvestPlantsApiHarvestPlantsAvailableGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<AvailableHarvestPlants> {
      return localVarFp
        .harvestPlantsAvailableGet(requestParameters.siteId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all harvest plant capacity for queried plan
     * @param {PlanningHarvestPlantsApiHarvestPlantsCapacityGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestPlantsCapacityGet(
      requestParameters: PlanningHarvestPlantsApiHarvestPlantsCapacityGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<HarvestPlantCapacity> {
      return localVarFp
        .harvestPlantsCapacityGet(
          requestParameters.planId,
          requestParameters.startDate,
          requestParameters.endDate,
          requestParameters.harvestPlantIds,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all harvest plants for queried plan
     * @param {PlanningHarvestPlantsApiHarvestPlantsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestPlantsGet(
      requestParameters: PlanningHarvestPlantsApiHarvestPlantsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<HarvestPlant>> {
      return localVarFp
        .harvestPlantsGet(requestParameters.planIds, requestParameters.siteId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete harvest plant by its identifier
     * @param {PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestPlantsHarvestPlantIdDelete(
      requestParameters: PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .harvestPlantsHarvestPlantIdDelete(requestParameters.harvestPlantId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get harvest plant by its identifier.
     * @param {PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestPlantsHarvestPlantIdGet(
      requestParameters: PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<HarvestPlant> {
      return localVarFp
        .harvestPlantsHarvestPlantIdGet(requestParameters.harvestPlantId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update a harvest plant
     * @param {PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestPlantsHarvestPlantIdPut(
      requestParameters: PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<HarvestPlant> {
      return localVarFp
        .harvestPlantsHarvestPlantIdPut(requestParameters.harvestPlantId, requestParameters.editHarvestPlant, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get harvest plant shifts.
     * @param {PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestPlantsHarvestPlantIdShiftsGet(
      requestParameters: PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<HarvestPlantShift>> {
      return localVarFp
        .harvestPlantsHarvestPlantIdShiftsGet(requestParameters.harvestPlantId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete harvest plant shift.
     * @param {PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdDelete(
      requestParameters: PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<HarvestPlantShift>> {
      return localVarFp
        .harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdDelete(
          requestParameters.harvestPlantId,
          requestParameters.harvestPlantShiftId,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get harvest plant shift by its identifier.
     * @param {PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdGet(
      requestParameters: PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<HarvestPlantShift> {
      return localVarFp
        .harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdGet(
          requestParameters.harvestPlantId,
          requestParameters.harvestPlantShiftId,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update harvest plant shift.
     * @param {PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdPut(
      requestParameters: PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<HarvestPlantShift> {
      return localVarFp
        .harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdPut(
          requestParameters.harvestPlantId,
          requestParameters.harvestPlantShiftId,
          requestParameters.editHarvestPlantShift,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Add harvest plant shift.
     * @param {PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestPlantsHarvestPlantIdShiftsPost(
      requestParameters: PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<HarvestPlantShift> {
      return localVarFp
        .harvestPlantsHarvestPlantIdShiftsPost(
          requestParameters.harvestPlantId,
          requestParameters.createHarvestPlantShift,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create harvest plant
     * @param {PlanningHarvestPlantsApiHarvestPlantsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestPlantsPost(
      requestParameters: PlanningHarvestPlantsApiHarvestPlantsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<HarvestPlant> {
      return localVarFp
        .harvestPlantsPost(requestParameters.createHarvestPlant, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for harvestPlantsAvailableGet operation in PlanningHarvestPlantsApi.
 * @export
 * @interface PlanningHarvestPlantsApiHarvestPlantsAvailableGetRequest
 */
export interface PlanningHarvestPlantsApiHarvestPlantsAvailableGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningHarvestPlantsApiHarvestPlantsAvailableGet
   */
  readonly siteId: string;
}

/**
 * Request parameters for harvestPlantsCapacityGet operation in PlanningHarvestPlantsApi.
 * @export
 * @interface PlanningHarvestPlantsApiHarvestPlantsCapacityGetRequest
 */
export interface PlanningHarvestPlantsApiHarvestPlantsCapacityGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningHarvestPlantsApiHarvestPlantsCapacityGet
   */
  readonly planId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningHarvestPlantsApiHarvestPlantsCapacityGet
   */
  readonly startDate?: string;

  /**
   *
   * @type {string}
   * @memberof PlanningHarvestPlantsApiHarvestPlantsCapacityGet
   */
  readonly endDate?: string;

  /**
   *
   * @type {Array<string>}
   * @memberof PlanningHarvestPlantsApiHarvestPlantsCapacityGet
   */
  readonly harvestPlantIds?: Array<string>;
}

/**
 * Request parameters for harvestPlantsGet operation in PlanningHarvestPlantsApi.
 * @export
 * @interface PlanningHarvestPlantsApiHarvestPlantsGetRequest
 */
export interface PlanningHarvestPlantsApiHarvestPlantsGetRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof PlanningHarvestPlantsApiHarvestPlantsGet
   */
  readonly planIds: Array<string>;

  /**
   *
   * @type {string}
   * @memberof PlanningHarvestPlantsApiHarvestPlantsGet
   */
  readonly siteId?: string;
}

/**
 * Request parameters for harvestPlantsHarvestPlantIdDelete operation in PlanningHarvestPlantsApi.
 * @export
 * @interface PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdDeleteRequest
 */
export interface PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdDelete
   */
  readonly harvestPlantId: string;
}

/**
 * Request parameters for harvestPlantsHarvestPlantIdGet operation in PlanningHarvestPlantsApi.
 * @export
 * @interface PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdGetRequest
 */
export interface PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdGet
   */
  readonly harvestPlantId: string;
}

/**
 * Request parameters for harvestPlantsHarvestPlantIdPut operation in PlanningHarvestPlantsApi.
 * @export
 * @interface PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdPutRequest
 */
export interface PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdPut
   */
  readonly harvestPlantId: string;

  /**
   *
   * @type {EditHarvestPlant}
   * @memberof PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdPut
   */
  readonly editHarvestPlant: EditHarvestPlant;
}

/**
 * Request parameters for harvestPlantsHarvestPlantIdShiftsGet operation in PlanningHarvestPlantsApi.
 * @export
 * @interface PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsGetRequest
 */
export interface PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsGet
   */
  readonly harvestPlantId: string;
}

/**
 * Request parameters for harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdDelete operation in PlanningHarvestPlantsApi.
 * @export
 * @interface PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdDeleteRequest
 */
export interface PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdDelete
   */
  readonly harvestPlantId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdDelete
   */
  readonly harvestPlantShiftId: string;
}

/**
 * Request parameters for harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdGet operation in PlanningHarvestPlantsApi.
 * @export
 * @interface PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdGetRequest
 */
export interface PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdGet
   */
  readonly harvestPlantId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdGet
   */
  readonly harvestPlantShiftId: string;
}

/**
 * Request parameters for harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdPut operation in PlanningHarvestPlantsApi.
 * @export
 * @interface PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdPutRequest
 */
export interface PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdPut
   */
  readonly harvestPlantId: string;

  /**
   *
   * @type {string}
   * @memberof PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdPut
   */
  readonly harvestPlantShiftId: string;

  /**
   *
   * @type {EditHarvestPlantShift}
   * @memberof PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdPut
   */
  readonly editHarvestPlantShift: EditHarvestPlantShift;
}

/**
 * Request parameters for harvestPlantsHarvestPlantIdShiftsPost operation in PlanningHarvestPlantsApi.
 * @export
 * @interface PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsPostRequest
 */
export interface PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsPostRequest {
  /**
   *
   * @type {string}
   * @memberof PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsPost
   */
  readonly harvestPlantId: string;

  /**
   *
   * @type {CreateHarvestPlantShift}
   * @memberof PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsPost
   */
  readonly createHarvestPlantShift: CreateHarvestPlantShift;
}

/**
 * Request parameters for harvestPlantsPost operation in PlanningHarvestPlantsApi.
 * @export
 * @interface PlanningHarvestPlantsApiHarvestPlantsPostRequest
 */
export interface PlanningHarvestPlantsApiHarvestPlantsPostRequest {
  /**
   *
   * @type {CreateHarvestPlant}
   * @memberof PlanningHarvestPlantsApiHarvestPlantsPost
   */
  readonly createHarvestPlant: CreateHarvestPlant;
}

/**
 * PlanningHarvestPlantsApi - object-oriented interface
 * @export
 * @class PlanningHarvestPlantsApi
 * @extends {BaseAPI}
 */
export class PlanningHarvestPlantsApi extends BaseAPI {
  /**
   *
   * @summary Get packaging codes
   * @param {PlanningHarvestPlantsApiHarvestPlantsAvailableGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestPlantsApi
   */
  public harvestPlantsAvailableGet(
    requestParameters: PlanningHarvestPlantsApiHarvestPlantsAvailableGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningHarvestPlantsApiFp(this.configuration)
      .harvestPlantsAvailableGet(requestParameters.siteId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all harvest plant capacity for queried plan
   * @param {PlanningHarvestPlantsApiHarvestPlantsCapacityGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestPlantsApi
   */
  public harvestPlantsCapacityGet(
    requestParameters: PlanningHarvestPlantsApiHarvestPlantsCapacityGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningHarvestPlantsApiFp(this.configuration)
      .harvestPlantsCapacityGet(
        requestParameters.planId,
        requestParameters.startDate,
        requestParameters.endDate,
        requestParameters.harvestPlantIds,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all harvest plants for queried plan
   * @param {PlanningHarvestPlantsApiHarvestPlantsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestPlantsApi
   */
  public harvestPlantsGet(
    requestParameters: PlanningHarvestPlantsApiHarvestPlantsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningHarvestPlantsApiFp(this.configuration)
      .harvestPlantsGet(requestParameters.planIds, requestParameters.siteId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete harvest plant by its identifier
   * @param {PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestPlantsApi
   */
  public harvestPlantsHarvestPlantIdDelete(
    requestParameters: PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningHarvestPlantsApiFp(this.configuration)
      .harvestPlantsHarvestPlantIdDelete(requestParameters.harvestPlantId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get harvest plant by its identifier.
   * @param {PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestPlantsApi
   */
  public harvestPlantsHarvestPlantIdGet(
    requestParameters: PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningHarvestPlantsApiFp(this.configuration)
      .harvestPlantsHarvestPlantIdGet(requestParameters.harvestPlantId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update a harvest plant
   * @param {PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestPlantsApi
   */
  public harvestPlantsHarvestPlantIdPut(
    requestParameters: PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningHarvestPlantsApiFp(this.configuration)
      .harvestPlantsHarvestPlantIdPut(requestParameters.harvestPlantId, requestParameters.editHarvestPlant, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get harvest plant shifts.
   * @param {PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestPlantsApi
   */
  public harvestPlantsHarvestPlantIdShiftsGet(
    requestParameters: PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningHarvestPlantsApiFp(this.configuration)
      .harvestPlantsHarvestPlantIdShiftsGet(requestParameters.harvestPlantId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete harvest plant shift.
   * @param {PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestPlantsApi
   */
  public harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdDelete(
    requestParameters: PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningHarvestPlantsApiFp(this.configuration)
      .harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdDelete(
        requestParameters.harvestPlantId,
        requestParameters.harvestPlantShiftId,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get harvest plant shift by its identifier.
   * @param {PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestPlantsApi
   */
  public harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdGet(
    requestParameters: PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningHarvestPlantsApiFp(this.configuration)
      .harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdGet(
        requestParameters.harvestPlantId,
        requestParameters.harvestPlantShiftId,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update harvest plant shift.
   * @param {PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestPlantsApi
   */
  public harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdPut(
    requestParameters: PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningHarvestPlantsApiFp(this.configuration)
      .harvestPlantsHarvestPlantIdShiftsHarvestPlantShiftIdPut(
        requestParameters.harvestPlantId,
        requestParameters.harvestPlantShiftId,
        requestParameters.editHarvestPlantShift,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Add harvest plant shift.
   * @param {PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestPlantsApi
   */
  public harvestPlantsHarvestPlantIdShiftsPost(
    requestParameters: PlanningHarvestPlantsApiHarvestPlantsHarvestPlantIdShiftsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningHarvestPlantsApiFp(this.configuration)
      .harvestPlantsHarvestPlantIdShiftsPost(
        requestParameters.harvestPlantId,
        requestParameters.createHarvestPlantShift,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create harvest plant
   * @param {PlanningHarvestPlantsApiHarvestPlantsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningHarvestPlantsApi
   */
  public harvestPlantsPost(
    requestParameters: PlanningHarvestPlantsApiHarvestPlantsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningHarvestPlantsApiFp(this.configuration)
      .harvestPlantsPost(requestParameters.createHarvestPlant, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
